import React from "react";
import styles from "./FollowUpCell.module.css";
import {ChatEventDTO, EventType} from "../../../../../../../api/generated";
import {WhiteTooltip} from "../../../../../../elements/tooltip/WhiteTooltip";
import {FollowUpCard} from "../../../../../../elements/followUpCard/FollowUpCard";

export const followUpEventsInPriorityOrder: EventType[] = [
    EventType.RequestedCallback,
    EventType.RequestedTestDrive,
    EventType.RequestedEmailFollowUp,
    EventType.RequestedServiceCallback,
    EventType.BookedTestDrive,
    EventType.BookedCallBack,
    EventType.BookedServiceCallBack,
    EventType.BookedEmailFollowUp,
];

interface FollowUpCellProps {
    chatEvents: ChatEventDTO[]
}


export const FollowUpCell: React.FC<FollowUpCellProps> = ({chatEvents}) => {

    const priorityMap = new Map<EventType, number>()
    followUpEventsInPriorityOrder.forEach((type, index) => {
        priorityMap.set(type, index);
    })

    const sortFollowUpEvents = (a: ChatEventDTO, b: ChatEventDTO) => {
        const priorityA = priorityMap.get(a.event_type) ?? Number.MAX_SAFE_INTEGER;
        const priorityB = priorityMap.get(b.event_type) ?? Number.MAX_SAFE_INTEGER;
        return priorityA - priorityB;
    }

    return <span className={styles.followUpCell}>
            {chatEvents
                .filter(chatEvent => followUpEventsInPriorityOrder.includes(chatEvent.event_type))
                .sort(sortFollowUpEvents)
                .slice(0, 1)
                .map(chatEvent => (
                    <FollowUpCard key={chatEvent.id} eventType={chatEvent.event_type}/>
                ))}
        {chatEvents.filter(chatEvent => followUpEventsInPriorityOrder.includes(chatEvent.event_type)).length > 1 && (
            <WhiteTooltip
                title={
                    <div className={styles.tooltipContent}>
                        {chatEvents
                            .filter(chatEvent => followUpEventsInPriorityOrder.includes(chatEvent.event_type))
                            .sort(sortFollowUpEvents)
                            .slice(1)
                            .map(chatEvent => (
                                <FollowUpCard key={chatEvent.id} eventType={chatEvent.event_type}/>
                            ))}
                    </div>
                }
            >
                <img src={"/infoIcon.svg"} alt={"more"} className={styles.infoIcon}/>
            </WhiteTooltip>
        )}
        </span>
}
